import { JsonConverter } from 'json2typescript';
import { HvlEnumConverter } from '@hvlng/framework-bff/util';

export enum EnumBpmnProcessType {
    PER_SUSPENSION_TIME = 'PER_SUSPENSION_TIME',
    PER_ADDRESS = 'PER_ADDRESS',
    PER_CERTIFICATE = 'PER_CERTIFICATE',
    PER_EDUCATION = 'PER_EDUCATION',
    PER_FAMILY = 'PER_FAMILY',
    PER_VEHICLE = 'PER_VEHICLE',
    PER_MILITARY = 'PER_MILITARY',
    PER_BANK = 'PER_BANK',
    PER_BORROWING = 'PER_BORROWING',
    PER_HEALTH = 'PER_HEALTH',
    PER_LEAVE_REQUEST = 'PER_LEAVE_REQUEST',
    PER_COMMISSION = 'PER_COMMISSION',
    PER_MOVEMENT = 'PER_MOVEMENT',
    ADAPTATION = 'ADAPTATION',
    PER_DECLARATION_GOODS = 'PER_DECLARATION_GOODS',
    PER_FOREIGN_LANGUAGE = 'PER_FOREIGN_LANGUAGE',
    PER_TELEPHONE = 'PER_TELEPHONE',
    PER_EXPERIENCE = 'PER_EXPERIENCE',
    PER_DISABILITY = 'PER_DISABILITY',
    ORG_VER = 'ORG_VER',
    PER_EXPENSE_INFO = 'PER_EXPENSE_INFO',
    OVERTIME = 'OVERTIME',
    ABSENCE_ENTRY = 'ABSENCE_ENTRY',
    INSURANCE_INFO = 'PER_INSURANCE_INFO',
    RECEIPT_INFO = 'PER_RECEIPT_INFO',
    PER_PASSPORT_DEMAND = 'PER_PASSPORT_DEMAND',
    PER_WORK_CERTIFICATE_DEMAND = 'PER_WORK_CERTIFICATE_DEMAND',
    CONFIRMATION_OF_NOBILITY = 'CONFIRMATION_OF_NOBILITY',
    PER_SKILL = 'PER_SKILL',
    PER_QUALITY= 'PER_QUALITY',
}

@JsonConverter
export class EnumBpmnProcessTypeConverter extends HvlEnumConverter<EnumBpmnProcessType> {
    constructor() {
        super(EnumBpmnProcessType, 'EnumBpmnProcessType');
    }
}
